import Vue from 'vue';
import store from '../../store';
import recipeTransformer from '../../transformers/recipe';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const recipes = recipeTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedRecipes', { recipes, pagination });
  resolve(recipes);
};

const failed = (error, reject) => reject();

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('production/recipe', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipe/items.js